import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { AccountService } from 'app/core';
import { Account, FieldDef } from 'app/core/models/account.types';
import { Dictionary } from 'app/shared/models';

@Component({
  selector: 'ethan-form-field-selection-modal',
  templateUrl: './ethan-form-field-selection-modal.component.html',
  styleUrls: ['./ethan-form-field-selection-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EthanFormFieldSelectionModal extends OnDestroyMixin implements OnInit {
  private account: Account;
  private conditionalLogic: any;
  public panelLogicForm: UntypedFormGroup;
  public error: string;
  public results: any;
  public inputFields: any;
  public currentFields: FieldDef[];
  public model = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
    private readonly matDialogRef: MatDialogRef<EthanFormFieldSelectionModal>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly accountService: AccountService,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
    this.account = this.accountService.getCurrentAccount();
  }

  ngOnInit(): void {
    this.model = this.data.results;
    this.inputFields = this.data.inputFields;

    const keysToCheck = Object.keys(this.model);

    this.currentFields = this.inputFields.filter((obj) => keysToCheck.some((key) => key == obj.name));
    this.cleanseData();
  }

  cleanseData(): void {
    this.currentFields.forEach((field) => {
      if (field.type === 'percent' || field.type === 'number' || field.type === 'money') {
        let strVal = this.model[field.name].toString();
        this.model[field.name] = parseFloat(strVal.replace(/[$%,]/g, ''));
      }
    });
  }

  onFieldUpdate(event: Dictionary<any>): void {}

  removeField(row): void {
    this.currentFields.splice(row, 1);
  }

  discard(): void {
    this.matDialogRef.close(undefined);
  }

  save(): void {
    let dataToSave = {};

    this.currentFields.forEach((field) => {
      dataToSave[field.name] = this.model[field.name];
    });

    this.matDialogRef.close({
      model: dataToSave,
    });
  }
}
